export default {"src":"/_next/static/media/7.d537dc93.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};